export function getFontSizeString(fontSize: number): string {
  // const {devicePixelRatio}  = window;
  // if (devicePixelRatio <= 2) {
  return `${fontSize}rem`
  // }
  // return `${fontSize / devicePixelRatio}rem`
}

const fonts = {
  family: {
    nice: '"Cuprum", cursive',
    chalk: '"Helvetica", "Arial", sans-serif'
  },
  size: {
    extraLarge: getFontSizeString(2.9),
    large: getFontSizeString(1.5),
    mediumLarge: getFontSizeString(1.3),
    medium: getFontSizeString(1),
    mediumSmall: getFontSizeString(.75),
    small: getFontSizeString(.7),
    extraSmall: getFontSizeString(.5),
  }
};


export default fonts;